import React from "react";
import { AssignedUserViewModel } from "../../../model/AssignedUserViewModel";
import { ExpertAssignmentRequestModel } from "../../../model/ExpertAssignmentRequestModel";

export interface SchedulerRoomExperts {
  examDayId: string;
  expertAssignments: ExpertAssignmentRequestModel[];
}

export interface SchedulerExpertContext {
  schedulerExperts: SchedulerRoomExperts[];
  changeExpert: (
    examDayId: string,
    roomId: string
  ) => (areFixed: boolean, selectedExperts: AssignedUserViewModel[]) => void;
}

export const initialSchedulerExpertContextValue: SchedulerExpertContext = {
  schedulerExperts: [],
  changeExpert:
    (examDayId: string, roomId: string) => (areFixed: boolean, selectedExperts: AssignedUserViewModel[]) => {},
};

export const SchedulerExpertContextValue = React.createContext<SchedulerExpertContext>(
  initialSchedulerExpertContextValue
);
